export default {
  createRoutingHistoryObject({ to, from }) {
    return {
      to: this.createRoutingHistoryObjectFor(to),
      from: this.createRoutingHistoryObjectFor(from)
    }
  },
  createRoutingHistoryObjectFor(routeObject) {
    return { name: routeObject.name, params: _castParamsToConsistentType(routeObject.params), query: routeObject.query }
  }
}

const _castParamsToConsistentType = (params) => {
  if (params?.id) {
    // after reload is the id a String, before an Number
    // without cast, isEqual will be unpredictable
    params.id = String(params.id);
  }
  return params;
}
